import { useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import useTranslation from '@hooks/useTranslation';

import type { IActionItemMetaInfo } from '@model/actionItemMetaInfo';

import { apiClient } from '@services/apiClient';

interface IMetaInfoStructure {
  [key: string]: {
    byKey: { [key: string]: string };
    list: Array<{ id: number; name: string }>;
  };
}

export const actionItemMetaInfoKey = () => ['actionItemMetaInfo'];
export const actionItemMetaInfo = () => apiClient.get(`${APP_API_URL_V2}fsd/action-item/meta-info`);

const getTranslateListItems = (t: (text: string) => string, listItems: { [key: string]: string }) => {
  const translatedListByKey: { [key: string]: string } = {};
  const translatedList = [];

  for (const key in listItems) {
    const name = t(listItems[key]);

    translatedListByKey[key] = name;
    translatedList.push({ id: +key, name });
  }

  return { byKey: translatedListByKey, list: translatedList };
};

const actionItemMetaInfoSelect = (data: IActionItemMetaInfo, t: (text: string) => string) => {
  const infoData: IMetaInfoStructure = {};

  for (const listKey in data) {
    infoData[listKey] = getTranslateListItems(t, data[listKey as keyof typeof data]);
  }

  return infoData;
};

export const useActionItemMetaInfoQuery = () => {
  const { t } = useTranslation();

  return useQuery({
    // @ts-ignore TODO: update react-query to v5
    queryKey: actionItemMetaInfoKey(),
    queryFn: actionItemMetaInfo,
    select: ({ data }: AxiosResponse<{ data: IActionItemMetaInfo }>) =>
      actionItemMetaInfoSelect(data.data, t),
  });
};
